var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { TemplateTypeDescription } from "./../models/V1/DocumentTemplates/TemplateTypeDescription";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
export class DocumentTemplatesTemplateTypes {
  /**
   * Creates an instance of DocumentTemplatesTemplateTypes.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof DocumentTemplatesTemplateTypes
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param TemplateTypesRq_ _templateTypesRq
   * @returns Promise<TemplateTypesRq_>
   * @memberof DocumentTemplatesTemplateTypes
   */
  templateTypes(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/DocumentTemplates/TemplateTypes", "GET", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: TemplateTypeDescription, isArray: true },
        { statusCode: 404, clazz: ApiError },
        { statusCode: 422, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
